<template>
	<!-- 编辑界面 -->
	<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40" @click="closeDialog">
		<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules">
			<el-form-item label="类型" prop="typeName">
				<el-input clearable v-model="editForm.typeName" placeholder="请输入类型" size="small" class="input_200px" />
			</el-form-item>
			<el-form-item label="系列" prop="productName">
				<el-input clearable v-model="editForm.productName" placeholder="请输入系列" size="small" class="input_200px" />
			</el-form-item>
			<el-form-item label="商品名称" prop="specification">
				<el-input clearable v-model="editForm.specification" placeholder="请输入商品名称" size="small" class="input_200px" />
			</el-form-item>
			<el-form-item label="价格(元)" prop="price">
				<el-input-number v-model.number="editForm.price" :min="0" :step="0.01" :precision="2" placeholder="请输入价格(元)" size="small" class="input_200px" />
			</el-form-item>
			<el-form-item label="单位" prop="unit">
				<el-input clearable v-model="editForm.unit" placeholder="请输入单位" size="small" class="input_200px" />
			</el-form-item>
			<el-form-item label="真实库存" prop="isWarehouse">
				<el-radio-group v-model="editForm.isWareHouse">
					<el-radio :label="true">是</el-radio>
					<el-radio :label="false">否</el-radio>
				</el-radio-group>
			</el-form-item>
		</el-form>
		<div class="drawer-footer">
			<el-button size="small" icon="el-icon-check" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
			<el-button v-if="$checkBtnPermission('/productType/index', 'delete')" size="small" icon="el-icon-delete" :loading="loading" class="title" type="danger" @click="handleDelete">删除</el-button>
		</div>
	</el-drawer>
</template>

<script>
import { SaveProductType, GetProductTypeDetail, DeleteProductType } from "@/api/productApi.js";
export default {
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			editFormVisible: false, //控制编辑页面显示与隐藏
			editForm: {
				keyId: "",
				typeName: "",
				productName: "",
				specification: "",
				price: 0,
				unit: "",
				isWarehouse: true
			},
			// rules 表单验证
			rules: {
				typeName: [{ required: true, message: "请输入类型名称", trigger: "blur" }],
				productName: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
				specification: [{ required: true, message: "请输入规格", trigger: "blur" }],
				price: [
					{ required: true, message: "请输入价格(元)", trigger: "blur" },
					{ type: "number", message: "请输入数字", trigger: "blur" }
				],
				unit: [{ required: true, message: "请输入单位", trigger: "blur" }]
			}
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {},
	components: {},
	methods: {
		//显示编辑界面
		editShow(row) {
			if (row != undefined && row != "undefined") {
				this.title = "编辑";
				let parmer = {
					keyId: row.keyId
				};
				GetProductTypeDetail(parmer)
					.then((res) => {
						if (res.code == 1) {
							this.editForm = res.data;
							this.editFormVisible = true;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error("获取商品类型详情失败!");
					});
			} else {
				this.title = "新增";
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.editFormVisible = true;
			}
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					SaveProductType(this.editForm)
						.then((res) => {
							if (res.code == 1) {
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "商品类型保存成功！"
								});
								this.editFormVisible = false;
								this.loading = false;
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error("商品类型保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
		},
		// 删除商品类型
		handleDelete() {
			this.$confirm("确认删除商品类型吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					DeleteProductType({ keyId: this.editForm.keyId })
						.then((res) => {
							if (res.code == 1) {
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "商品类型删除成功！"
								});
								this.editFormVisible = false;
								this.loading = false;
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error("商品类型删除失败，请稍后再试！");
						});
				})
				.catch((err) => {
					console.log(err);
					this.$message({
						type: "info",
						message: "已取消删除"
					});
				});
		}
		//
	}
};
</script>
<style scoped>
.wip {
	width: 200px !important;
}
</style>
